export type OrganizationSettingsTab =
  | "settings"
  | "team"
  | "secrets"
  | "billing";

export const ORGANIZATION_SETTINGS_TAB_QUERY_PARAM = "tab";
export const ORGANIZATION_SETTINGS_SECRET_QUERY_PARAM = "secretId";

const organizationSettingsTabs = new Set<OrganizationSettingsTab>([
  "settings",
  "team",
  "secrets",
  "billing",
]);

export const getOrganizationSettingsTabFromSearch = (
  search = "",
): OrganizationSettingsTab => {
  const tab = new URLSearchParams(search).get(
    ORGANIZATION_SETTINGS_TAB_QUERY_PARAM,
  );

  return organizationSettingsTabs.has(tab as OrganizationSettingsTab)
    ? (tab as OrganizationSettingsTab)
    : "settings";
};

export const buildOrganizationSettingsTabHref = (
  activeOrgId: string,
  tab: OrganizationSettingsTab = "settings",
  search = "",
) => {
  const pathname = activeOrgId
    ? `/org/${activeOrgId}/settings`
    : "/org/settings";
  const existingParams = new URLSearchParams(search);
  const params = new URLSearchParams();

  if (tab !== "settings") {
    params.set(ORGANIZATION_SETTINGS_TAB_QUERY_PARAM, tab);
  }

  existingParams.forEach((value, key) => {
    if (key !== ORGANIZATION_SETTINGS_TAB_QUERY_PARAM) {
      params.append(key, value);
    }
  });

  const queryString = params.toString();
  return `${pathname}${queryString ? `?${queryString}` : ""}`;
};

export const getOrganizationSettingsSecretIdFromSearch = (search = "") =>
  new URLSearchParams(search).get(ORGANIZATION_SETTINGS_SECRET_QUERY_PARAM) ||
  undefined;

export const buildOrganizationSettingsSecretHref = (
  organizationId: string,
  secretId: string,
  search = "",
) => {
  const params = new URLSearchParams(search);
  params.set(ORGANIZATION_SETTINGS_SECRET_QUERY_PARAM, secretId);
  return buildOrganizationSettingsTabHref(
    organizationId,
    "secrets",
    params.toString(),
  );
};

export const buildOrganizationSettingsSecretsHref = (
  organizationId: string,
  search = "",
) => {
  const params = new URLSearchParams(search);
  params.delete(ORGANIZATION_SETTINGS_SECRET_QUERY_PARAM);
  return buildOrganizationSettingsTabHref(
    organizationId,
    "secrets",
    params.toString(),
  );
};

export const getOrganizationSettingsTabRedirectHref = ({
  activeOrgId,
  routeOrgId,
  tab,
  search = "",
}: {
  activeOrgId?: string;
  routeOrgId?: string;
  tab: OrganizationSettingsTab;
  search?: string;
}) => {
  const organizationId = routeOrgId || activeOrgId;

  return organizationId
    ? buildOrganizationSettingsTabHref(organizationId, tab, search)
    : null;
};
